class Header {
  constructor(component) {
    this.refs = {
      triggerElement: '[data-background]',
    };
    
    this.dom = {
      $component: component,
      $triggerElements: document.querySelectorAll(this.refs.triggerElement),
    };

    this.state = {
      viewportHeight: window.innerHeight,
      observer: null,
    };

    this.init();

    this.mount();
  }

  mount() {
    const { dom, state } = this;

    window.addEventListener('resize', () => {
      if (window.innerHeight !== this.state.viewportHeight) {
        this.state.viewportHeight = window.innerHeight;
      }
    });

    dom.$triggerElements.forEach(el => {
      state.observer.observe(el);
    });
  }

  init() {
    const { dom } = this;
    this.initIntersectionObserver();
    setTimeout(() => {
      dom.$component.classList.add('is-initialized');
    }, 250);
  }

  initIntersectionObserver() {
    const { dom, state } = this;

    const bottomRootMargin = -(Math.round(state.viewportHeight - 65)) + 'px';

    // add intersection observer for background elements
    state.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const bgColor = entry.target.getAttribute('data-background');
          // remove any existing bg- classes
          dom.$component.className = dom.$component.className
            .split(' ')
            .filter(c => !c.startsWith('theme-'))
            .join(' ');
          // add new bg- class
          dom.$component.classList.add(`theme-${bgColor}`);
        }
      });
    }, {
      root: null,
      rootMargin: `0px 0px ${bottomRootMargin} 0px`,
    });
  }
}

const $header = document.querySelector('.js-header');
if ($header) new Header($header);